import * as React from "react";
import EditParameter from "../../Editing/EditParameter";
import Table from "../../../components/Table/Table";
import { Dimmer } from "semantic-ui-react";
import { setParameterExtraProperties } from "../../../utils/pdApiUtils";
import { editActions } from "../../../actions/editActions";
import { pdApiActions } from "../../../actions/pdApiActions";
import { driveVersionFilter } from "../../../utils/utils";
import { mainActions } from "../../../actions/mainActions";
import { Filter } from "../../../components/Table/Migration/LegacyTypes";
import _ from "lodash";
import { visibilityOptions } from "../../../utils/pdApiUtils";
import { getDependentDriveParametersColumns } from "../../../reducers/parameterTableConfig";
/**
 * All the following props are passed from parent component
 */
export type DriveParametersTableProps = {
  pdApi: State.PdApi;
  columns: State.ColumnMap;
  mainState: State.Main;
  editedObjectId: number | undefined;
  isEditActive: boolean;
  isLoadingParameters: boolean;
  pdApiActions: typeof pdApiActions;
  editActions: typeof editActions;
  mainActions: typeof mainActions;
  subMenuRoute: State.DriveSubmenu;
  toggleModal: () => void;
  filterOptions: State.FilterOptions;
  columnFilters: Filter[];
  setColumnFilters: (subMenuRoute: State.DriveSubmenu, columnFilter: Filter[]) => void;
};

type DriveParametersTableState = {
  isModalOpen: boolean;
};

export class DriveParametersTable extends React.Component<
  DriveParametersTableProps,
  DriveParametersTableState
> {
  state = {
    isModalOpen: false
  };

  componentWillUnmount(): void {
    this.props.mainActions.setLastEditedObjectId(undefined);
  }

  componentDidMount(): void {
    // make throttle function
    this.handleFilterChangeDebounced = _.debounce(this.handleFilterChangeDebounced, 500);
  }

  private handleFilterChangeDebounced = (changedFilters: Filter[]) => {
    this.props.setColumnFilters(this.props.subMenuRoute, changedFilters);
  };

  render(): JSX.Element {
    const {
      columns,
      pdApi,
      mainState,
      isEditActive,
      toggleModal,
      filterOptions,
      isLoadingParameters
    } = this.props;
    const { driveParameters } = pdApi;
    const { editSize, pageSize, isShortenTextEnabled } = mainState;
    let driveParametersRows: Api.DriveParameter[] = [];
    let filteredRows: Api.DriveParameter[] = [];
    let selectedColumns: State.Column[] = [];

    driveParametersRows = (driveParameters) ? driveParameters.map(
      row => setParameterExtraProperties(row, pdApi) as Api.DriveParameter
    ) : [];
    filteredRows = driveVersionFilter(driveParametersRows, filterOptions.selectedDriveVersion);
    selectedColumns = columns["Drive Parameters"];
    // Add submenu specific columns and rows
    const startingPage = mainState.lastEditedObjectId
      ? (filteredRows.findIndex(parameter => parameter.id === mainState.lastEditedObjectId) / // tslint:disable-line: no-bitwise
          mainState.pageSize) >>
        0
      : 0;

    const filterDropdownOptions = visibilityOptions.map(option => option.text);

    selectedColumns = getDependentDriveParametersColumns(
      columns["Drive Parameters"],
      filterDropdownOptions
    );

    return (
      <div className="flex-1">
        <div className="flex-1">
          <Table
            startingPage={startingPage}
            rows={filteredRows}
            loading={isLoadingParameters}
            loadingText="Fetching drive parameters..."
            columns={selectedColumns}
            isHidingTextActive={isShortenTextEnabled}
            handleRowSelection={this.props.editActions.select}
            isRowSelected={this.isParameterSelected}
            pageSize={pageSize}
            handleFilterChange={this.handleFilterChangeDebounced}
          />
        </div>
        {isEditActive && (
          <Dimmer active={true} page={true}>
            <div
              className="edit-view"
              style={{ flex: editSize, width: editSize == 0.3 ? "500px" : "1000px" }}
            >
              <EditParameter toggleModal={toggleModal} groupName="Drive" columns={columns} />
            </div>
          </Dimmer>
        )}
      </div>
    );
  }
  /**
   * Returns status if parameter has been selected
   * @param {Api.AnyParameter} fault
   * @returns {boolean}
   */
  private isParameterSelected = (parameter: Api.AnyParameter): boolean => {
    const editedObjectId = this.props.editedObjectId ?? this.props.mainState.lastEditedObjectId;
    if (editedObjectId && parameter.id === editedObjectId) {
      return true;
    } else {
      return false;
    }
  };
}

export default DriveParametersTable;
